import {ChangeDetectorRef, Component, Input, OnInit, OnDestroy, ViewChild, OnChanges, SimpleChanges} from '@angular/core';
import {UserService} from '../../services/user.service';
import {TdoUserConfigurationModel} from '../../models/configuration/user/tdo-user-configuration.model';
import {TdoDropdownModel} from '../../tdo-controls/common/tdo-basic-dropdown/models/tdo-dropdown.model';
import {StaticDataService} from '../../services/static-data.service';
import {EnumValidValueItemModel} from '../../models/enum/enum-valid-value-item.model';
import {MatDialog} from '@angular/material/dialog';
import {TreatmentFracturesDialogComponent} from './dialogs/treatment-fractures-dialog/treatment-fractures-dialog.component';
import {TreatmentAnesthesiaDialogComponent} from './dialogs/treatment-anesthesia-dialog/treatment-anesthesia-dialog.component';
import {TreatmentXrayDataDialogComponent} from './dialogs/treatment-xray-data-dialog/treatment-xray-data-dialog.component';
import {MessagingConstants} from '../../models/MessagingConstants';
import {MessagingService} from '../../services/messaging.service';
import {NotesService} from '../../services/notes.service';
import {Globals} from '../../globals';
import {TreatmentTeethGroupDialogComponent} from './dialogs/treatment-teeth-group-dialog/treatment-teeth-group-dialog.component';
import {TreatmentPerforationDialogComponent} from './dialogs/treatment-perforation-dialog/treatment-perforation-dialog.component';
import {TreatmentService} from '../../services/treatment.service';
import {TreatmentEndoDataModel} from './models/treatment-endo-data.model';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {formatDate} from '@angular/common';
import {TreatmentEndoCanalDataModel, treatmentEndoTeethGroupCanal} from './models/treatment-endo-canal-data.model';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import {TreatmentEndoCanalEnumService} from './treatment-endo-canal-enum.service';
import {TreatmentEndoEditColumnDialogComponent} from './dialogs/treatment-endo-edit-column-dialog/treatment-endo-edit-column-dialog.component';
import {TreatmentEndoEditColumnModel} from './models/treatment-endo-edit-column.model';
import {TreatmentEndoEditRowDialogComponent} from './dialogs/treatment-endo-edit-row-dialog/treatment-endo-edit-row-dialog.component';
import {TreatmentEndoAutofillItemModel} from './models/configuration/treatment-endo-autofill-item.model';
import {TdoNoteAssociatedObject, TdoNoteSaveModel} from '../../main-interface/controls/tdo-notes/models/tdo-note-save-model';
import {TdoNoteQueryModel} from '../../main-interface/controls/tdo-notes/models/tdo-note-query.model';
import {DialogService} from '../../services/dialog.service';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {TdoDropdownChange} from '../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import {PatientCaseWorkItemFormDataModel} from '../../models/forms/data/patient-case-work-item-form-data.model';
import {NoteCategoryEnum} from '../../models/enum/note-category.enum';
import {NoteTypeEnum} from '../../models/enum/note-type.enum';
import {TreatmentUtils} from './utils/treatment-utils';
import { ARService } from '../ar/ar.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { tap, switchMap, take } from 'rxjs/operators';
import { lastValueFrom, ReplaySubject, Subscription } from 'rxjs';


@Component({
  standalone: false,
  selector: 'app-treatment',
  templateUrl: './treatment.component.html',
  styleUrls: ['./treatment.component.scss']
})


export class TreatmentComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('detailTable') detailTable: MatTable<TreatmentEndoCanalDataModel>;

  @Input() caseWorkItemId: string = '00000000-0000-0000-0000-000000000000';
  @Input() caseWorkItemFormsId: string = '00000000-0000-0000-0000-000000000000';
  @Input() form: PatientCaseWorkItemFormDataModel;

  assistantPredicate: (data: TdoUserConfigurationModel) => string;

  emptyGuid = '00000000-0000-0000-0000-000000000000';
  isLoading = true;
  toothNum = 6;
  NOTE_SAVING_STEP_THRESHOLD = 3;

  assistants: TdoUserConfigurationModel[] = [];
  displayedColumns: string[] = ['Option', 'ToothNum', 'PulpStatus', 'EWL', 'Reference', 'AWL', 'ApicalCurvature', 'FFB', 'MAF', 'GPS', 'Sealer', 'Fill', 'MoO', 'IAM', 'CoronalEndo', 'Clear'];

  // Top dropdown models and properties
  toothCanalDropDownModels: TdoDropdownModel[] = [];
  assistantDropdownModels: TdoDropdownModel[] = [];
  occlusionReductionDropdownModels: TdoDropdownModel[] = [];
  irrigationProtocolDropdownModels: TdoDropdownModel[] = [];
  instrumentProtocolDropdownModels: TdoDropdownModel[] = [];
  totalIrrigationVolumeDropdownModels: TdoDropdownModel[] = [];

  filterValue = 'Tooth';
  TreatmentEwlAwlFilter: string = 'TreatmentEwlAwlFilter';
  isTreatmentEwlAwlFilter = false;
  selectedGroup: string;

  // Bottom dropdown models and properties
  bleedingDropdownModels: TdoDropdownModel[] = [];
  intraOperativePainDropdownModels: TdoDropdownModel[] = [];
  existingRestorationDropdownModels: TdoDropdownModel[] = [];
  requestCoronalEndoDropdownModels: TdoDropdownModel[] = [];
  clampDropdownModels: TdoDropdownModel[] = [];
  pretreatmentDropdownModels: TdoDropdownModel[] = [];
  biteBlockDropdownModels: TdoDropdownModel[] = [];

  globalAutoConfigsStaticData = [1, 2, 3, 4];

  // Interim Report dropdown models
  interimReportExtTreatmentDropdownModels: TdoDropdownModel[] = [];
  interimReportFollowUpInDropdownModels: TdoDropdownModel[] = [];

  treatmentModel: TreatmentEndoDataModel = new TreatmentEndoDataModel();
  treatmentAutofillModels: TreatmentEndoAutofillItemModel[];

  canalDataSource = new MatTableDataSource<TreatmentEndoCanalDataModel>();
  treatmentEndoTeethGroupCanal: treatmentEndoTeethGroupCanal[] = [];
  currentCanalDataSource: TreatmentEndoCanalDataModel[] = [];
  isUserInput: boolean = false;

  // Queuing system properties
  private saveQueueTimeout: any;
  private currentSaveSubscription: Subscription | null = null;
  private readonly SAVE_DEBOUNCE_DELAY = 300; // 300ms delay
  private formDataReady$ = new ReplaySubject<void>(1);

  constructor(private readonly userService: UserService,
              private readonly dialogService: DialogService,
              private readonly messagingService: MessagingService,
              private readonly notesService: NotesService,
              private readonly treatmentService: TreatmentService,
              public readonly canalEnumService: TreatmentEndoCanalEnumService,
              private readonly globals: Globals,
              private readonly dialog: MatDialog,
              private readonly staticDataService: StaticDataService,
              private readonly arService: ARService,
              private readonly localStorageService: LocalStorageService,
              private readonly cdr: ChangeDetectorRef) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.caseWorkItemFormsId && changes.caseWorkItemFormsId.currentValue !== changes.caseWorkItemFormsId.previousValue) {
      this.loadTreatmentData();
    }
  }

  ngOnInit(): void {
    this.assistantPredicate = (data: TdoUserConfigurationModel) => {
      return data.FirstName + ' ' + data.LastName;
    };

    this.loadFormData();   
  }

  loadFormData() {
    lastValueFrom(this.arService.getUserParams(this.localStorageService.currentUserData.authdata.userid, this.TreatmentEwlAwlFilter)).then(params => {
      this.isTreatmentEwlAwlFilter = params?.ParameterValue === 'true';
      if(this.isTreatmentEwlAwlFilter){
        localStorage.setItem('isTreatmentEwlAwlFilter', 'true');
      }
      else{
        localStorage.setItem('isTreatmentEwlAwlFilter', 'false');
      }
    });

    // Get Assistants
    this.userService.getAssistantUsers(this.globals.TDOCID).subscribe({
      next: (allUsers) => {
        this.assistants = allUsers.sort((a, b) => (a.FirstName ?? '').toLocaleLowerCase().localeCompare((b.FirstName ?? '').toLocaleLowerCase()));
        for (const model of this.assistants) {
          this.assistantDropdownModels.push(new TdoDropdownModel(model.FirstName + ' ' + model.LastName, model));
        }

        this.treatmentService.getTreatmentAutoFillConfigurationModels().subscribe({
          next: (autoRes) => {
            this.treatmentAutofillModels = autoRes;

            if (this.staticDataService.validValues && this.staticDataService.validValueItems) {
              this.setValidValues();
              this.cdr.detectChanges();
            } else {
              this.staticDataService.validValuesReadyEvent.subscribe({
                complete: () => {
                  this.setValidValues();
                  this.cdr.detectChanges();
                }
              });
            }
          },
          error: (err) => this.formDataReady$.error(err),
        });
      },
      error: (err) => this.formDataReady$.error(err),
    });
  }

  ngOnDestroy(): void {
    // Clean up queuing system resources
    if (this.saveQueueTimeout) {
      clearTimeout(this.saveQueueTimeout);
      this.saveQueueTimeout = null;
    }
    this.formDataReady$.complete();
  }

  loadTreatmentData() {
    this.isLoading = true;
    this.formDataReady$.pipe(take(1)).subscribe({
      next: () => this.fetchTreatment(),
      error: () => { this.isLoading = false; this.cdr.detectChanges(); },
    });
  }

  private fetchTreatment() {
    this.treatmentService.getTreatment(this.globals.currentPatientId, this.caseWorkItemFormsId).subscribe({
      next: (treatmentModelResponse) => {
        if (treatmentModelResponse) {
          const noteQueryModel = new TdoNoteQueryModel();
          noteQueryModel.parentObjectName = 'dataTreatmentEndo';
          noteQueryModel.objectId = treatmentModelResponse.TreatmentID;
          noteQueryModel.patientId = this.globals.currentPatientId;
          noteQueryModel.categoryEnumId = NoteCategoryEnum.TreatmentPageSummary;
          noteQueryModel.typeEnumId = NoteTypeEnum.Case;
          this.notesService.changeNoteQuery(noteQueryModel);

          this.treatmentModel = treatmentModelResponse;
          this.canalDataSource.data = this.treatmentModel.dataTreatmentEndoCanals;
          this.currentCanalDataSource = this.treatmentModel.dataTreatmentEndoCanals;
          this.canalDataSource._updateChangeSubscription();
        }
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('TreatmentComponent loadTreatmentData error:', error);
        this.isLoading = false;
        this.cdr.detectChanges();
      },
    });
  }
  // Private methods
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  private setValidValues() {
    this.toothCanalDropDownModels = this.createEnumDropdownModels('enumToothCanal');
    this.occlusionReductionDropdownModels = this.createEnumDropdownModels('enumEndoOcclusionReduction');
    this.irrigationProtocolDropdownModels = this.createEnumDropdownModels('enumEndoIrrigationProtocol');
    this.instrumentProtocolDropdownModels = this.createEnumDropdownModels('enumEndoInstrumentProtocol');
    this.totalIrrigationVolumeDropdownModels = this.createEnumDropdownModels('enumEndoIrrigationVolumUsed');

    this.bleedingDropdownModels = this.createEnumDropdownModels('enumEndoBleeding');
    this.existingRestorationDropdownModels = this.createEnumDropdownModels('enumEndoExistingRestoration');
    this.requestCoronalEndoDropdownModels = this.createEnumDropdownModels('enumEndoRequestedCoronalEndo');
    this.intraOperativePainDropdownModels = this.createEnumDropdownModels('enumEndoIntraOperatoryPain');
    this.clampDropdownModels = this.createEnumDropdownModels('enumEndoClamp');
    this.pretreatmentDropdownModels = this.createEnumDropdownModels('enumEndoPretreatment');
    this.biteBlockDropdownModels = this.createEnumDropdownModels('enumEndoBiteBlock');

    this.interimReportFollowUpInDropdownModels = this.createEnumDropdownModels('enumEndoInterimReportFollowIn');
    this.interimReportExtTreatmentDropdownModels = this.createEnumDropdownModels('enumEndoInterimReportExtTreatment');
    this.formDataReady$.next();
  }

  private createEnumDropdownModels(enumName: string): TdoDropdownModel[] {
    const enums = this.staticDataService.getValidValueItemsByValidValueName(enumName);
    const ddModels: TdoDropdownModel[] = [];
    if (enums) {
      for (const vvi of enums) {
        ddModels.push(new TdoDropdownModel(vvi.ItemDisplayValue, vvi));
      }
    }
    return ddModels;
  }

  // Top buttons
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  onAnesthesiaClick() {
    this.dialog.open(TreatmentAnesthesiaDialogComponent, {
      width: '1000px',
      height: '600px',
      panelClass: 'dialog',
      data: this.treatmentModel
    });
  }

  onFracturesClick() {
    const dialogRef = this.dialog.open(TreatmentFracturesDialogComponent, {
      width: '1200px',
      height: '600px',
      panelClass: 'dialog',
      data: {CaseWorkItemToothId: this.form.dataPatientCaseItemFormTeeth[0].CaseWorkItemToothId, toothNum: this.form.dataPatientCaseItemFormTeeth[0].Notation}
    });
  }

  onXRaysDataClick() {
    const dialogRef = this.dialog.open(TreatmentXrayDataDialogComponent, {
      width: '340px',
      height: '270px',
      panelClass: 'dialog',
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response && response.length > 0) {
        const model = new TdoNoteSaveModel();
        model.patientId = this.globals.currentPatientId;

        const associatedObjects = [];
        const newAssociatedObjectCase = new TdoNoteAssociatedObject();
        newAssociatedObjectCase.objectId = this.globals.currentPatientCaseId;
        newAssociatedObjectCase.parentObjectName = 'dataPatientCase';
        associatedObjects.push(newAssociatedObjectCase);

        const associatedObjectTreatment = new TdoNoteAssociatedObject();
        associatedObjectTreatment.parentObjectName = 'dataTreatmentEndo';
        associatedObjectTreatment.objectId = this.treatmentModel.TreatmentID;

        model.associatedObjects = associatedObjects;
        model.text = response;
        model.categoryEnumIds.push('00000018-1000-0000-0000-000000000021');
        model.typeEnumIds.push(NoteTypeEnum.Patient);
        this.messagingService.sendComponentMessage(MessagingConstants.NOTES_CREATE_NOTE, model);
      }
    });
  }

  onGroupsClick() {
   const dialogRef = this.dialog.open(TreatmentTeethGroupDialogComponent, {
     width: '600px',
     height: '400px',
     panelClass: 'dialog',
     data: this.treatmentModel
   });

   dialogRef.afterClosed().subscribe(() => {
    if (this.filterValue ===  'Group') {
      setTimeout(() => {  this.onShowFilter(); }, 1000);
    }
  });
}

  onSendInterimReportClick() {
    //
  }

  onGentleWaveStartProcedureClick() {
    //
  }

  onGentleWaveLogClick() {
    //
  }

  onPerforationClick() {
    const dialogRef = this.dialog.open(TreatmentPerforationDialogComponent, {
      width: '1100px',
      height: '700px',
      panelClass: 'dialog',
      data: {perforationModels: this.treatmentModel.dataTreatmentEndoPerforations, treatmentId: this.treatmentModel.TreatmentID, classType: '00000153-1000-0000-0000-000000000002', toothNum: this.toothNum.toString()}
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        /*const perfModel = res as TreatmentEndoPerforationDataModel;
        const idx = this.treatmentModel.dataTreatmentEndoPerforations.findIndex(p => p.TretmentPerfID === perfModel.TretmentPerfID);
        if (idx === -1) {
          this.treatmentModel.dataTreatmentEndoPerforations.push(perfModel);
        }*/
        this.treatmentModel.dataTreatmentEndoPerforations = res;
      }
    });
  }


  onCompletedInputFinished(event: any, inputType: string) {
   
    switch (inputType) {
      case 'CompletedDate':
        this.treatmentModel.CompleteDate = event;
        this.saveTreatment();
        break;
      case 'CompleteTreatmentByDate':
        this.treatmentModel.EndoTreatmentDateBy = event;
        this.saveTreatment();
        break;
      case 'InterimReportSent':
        this.treatmentModel.InterimReportDate = event;
        if (this.treatmentModel.enumEndoInterimReportFollowInID) {
          this.treatmentModel.InterimReportSentOn = new Date(this.getFollowUpInDate(this.treatmentModel.enumEndoInterimReportFollowInID));
        }
        this.saveTreatment();
        break;
      case 'InterimReportSentOn':
        this.treatmentModel.InterimReportSentOn = event;
        this.saveTreatment();
        break;
    }
  }

  getFollowUpInDate(enumId: string) {
    let numDays = 0;
    switch (enumId) {
      case '00000154-1000-0000-0000-000000000001':
        numDays = 7;
        break;
      case '00000154-1000-0000-0000-000000000002':
        numDays = 14;
        break;
      case '00000154-1000-0000-0000-000000000003':
        numDays = 21;
        break;
      case '00000154-1000-0000-0000-000000000004':
        numDays = 30;
        break;
      case '00000154-1000-0000-0000-000000000005':
        numDays = 60;
        break;
      case '00000154-1000-0000-0000-000000000006':
        numDays = 90;
        break;
    }
    const date = new Date(this.treatmentModel.InterimReportDate);
    const followUpDate = new Date(date.setDate(date.getDate() + numDays));
    const returnDate = formatDate(followUpDate, 'shortDate', 'en');
    return returnDate;
  }

  /**
   * Queues the saveTreatment function to ensure only the last call is processed
   * when multiple calls are made in quick succession
   */
  private queueSaveTreatment(): void {
    // Clear any existing timeout
    if (this.saveQueueTimeout) {
      clearTimeout(this.saveQueueTimeout);
    }

    // Cancel any ongoing save operation
    if (this.currentSaveSubscription) {
      this.currentSaveSubscription.unsubscribe();
      this.currentSaveSubscription = null;
    }

    // Set a new timeout to execute the save after the debounce delay
    this.saveQueueTimeout = setTimeout(() => {
      this.executeSaveTreatment();
    }, this.SAVE_DEBOUNCE_DELAY);
  }

  /**
   * Executes the actual save treatment operation
   */
  private executeSaveTreatment(): void {
    // Cancel any existing subscription before making a new request
    if (this.currentSaveSubscription) {
      this.currentSaveSubscription.unsubscribe();
    }

    this.currentSaveSubscription = this.treatmentService.saveTreatment(this.treatmentModel).subscribe((returnModel) => {
      this.treatmentModel = returnModel;
      // Clear the subscription reference after completion
      this.currentSaveSubscription = null;
    }, (error) => {
      console.error('Error saving treatment:', error);
      this.currentSaveSubscription = null;
    });
  }

  saveTreatment() {
    this.queueSaveTreatment();
  }

  getDropdownValue(enumItemID: string, subset: TdoDropdownModel[]) {
    const model = subset.find(p => p.value.ValidValueItemId === enumItemID);
    if (model) {
      return model;
    }

    return null;
  }

  onShowFilter() {
    if (this.filterValue === 'Tooth') {
      // Get unique tooth IDs from currentCanalDataSource
      const toothIds = [...new Set(this.currentCanalDataSource.map(item => item.TreatmentCanalID))];
      // Filter canalDataSource to only include records with matching tooth IDs
      this.canalDataSource.data = this.canalDataSource.data.filter(x =>
        toothIds.includes(x.TreatmentCanalID)
      );
    } else if (this.filterValue === 'Group') {
      this.treatmentService.getTreatmentCanalGroupByTreatmentID(this.treatmentModel.TreatmentID).subscribe((res) => {
        if (res) {
          this.selectedGroup = res;
          this.getTreatmentCanalByGroup(this.selectedGroup);
        }
        else{
          this.canalDataSource.data = this.currentCanalDataSource;
        }
      });
    }
    this.canalDataSource._updateChangeSubscription();
  }

  getTreatmentCanalByGroup(groupId: string) {
    if (groupId) {
      this.treatmentService.getTreatmentCanalTeethByGroup(groupId, this.globals.currentPatientId)
        .pipe(
          tap((teethGroupCanal) => {
            this.treatmentEndoTeethGroupCanal = teethGroupCanal;
          }),
          switchMap(() => this.treatmentService.getTreatmentCanalByGroup(groupId))
        )
        .subscribe((res) => {
          this.treatmentModel.dataTreatmentEndoCanals = res.dataTreatmentEndoCanals;
          this.treatmentModel.cfgTeeth = res.cfgTeeth;
          this.canalDataSource.data = this.treatmentModel.dataTreatmentEndoCanals;
          this.canalDataSource._updateChangeSubscription();
        });
    }
  }


  onDropdownItemSelected(event: EnumValidValueItemModel, modelEnum: string) {
    if( event.ValidValueItemId === undefined || !this.isUserInput) {
      return;
    }

    // objectId is 'S-<TreatmentID guid>-<control name>'; most model properties are the
    // control name plus an 'ID' suffix, but a few (enumEndoBiteBlock) match the column name exactly.
    const controlName = event.objectId.substring(39);

    if(modelEnum !== controlName + 'ID' && modelEnum !== controlName) {
      return;
    }


    this.treatmentModel[modelEnum] = event.ValidValueItemId;

    if (modelEnum === 'enumEndoInterimReportFollowInID') {
      if (this.treatmentModel.InterimReportDate) {
        this.treatmentModel.InterimReportSentOn = new Date(this.getFollowUpInDate(this.treatmentModel.enumEndoInterimReportFollowInID));
      }
    }

    this.saveTreatment();
  }

  onCheckboxChange(event: MatCheckboxChange, modelPropertyName: string) {
    
    this.treatmentModel[modelPropertyName] = event.checked;
    this.saveTreatment();
  }

  getPerfType() {
    if (this.treatmentModel && this.treatmentModel.dataTreatmentEndoPerforations && this.treatmentModel.dataTreatmentEndoPerforations.length > 0) {
      const enumItem = this.staticDataService.getValidValueItemsByItemIds([this.treatmentModel.dataTreatmentEndoPerforations[0].enumEndoPerfTypeID])[0];
      if (enumItem) {
        return enumItem.ItemDisplayValue;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  onCanalRowDetailDropdownChange(event: TdoDropdownModel, row: TreatmentEndoCanalDataModel) {
    row.enumToothCanalID = event.value.value.ValidValueItemId;
    this.treatmentService.saveCanalItem(row).subscribe((res) => {
      const idx = this.treatmentModel.dataTreatmentEndoCanals.findIndex(p => p.TreatmentCanalID === row.TreatmentCanalID);
      if (idx > -1) {
        this.treatmentModel.dataTreatmentEndoCanals[idx] = res;
      }
    });
  }

  getDocumentFormToothNumber(row?: any) {
    if (this.treatmentModel?.cfgTeeth?.length === 1) {
      return this.treatmentService.getToothNumber(this.treatmentModel, null);
    }
    else if (row) {
      return this.treatmentEndoTeethGroupCanal.find(x => x.CaseWorkItemFormsToothId === row.CaseWorkItemToothId) !== undefined ? this.treatmentEndoTeethGroupCanal.find(x => x.CaseWorkItemFormsToothId === row.CaseWorkItemToothId).Notation : '';
    }

  }

  onDeleteCanalRow(row: TreatmentEndoCanalDataModel) {
    this.dialogService.openConfirmDialog('Are you sure you want to delete this row?').subscribe((isConfirmed) => {
      if (isConfirmed) {
        this.treatmentService.deleteCanalItem(row).subscribe((res) => {
          const idx = this.treatmentModel.dataTreatmentEndoCanals.findIndex(p => p.TreatmentCanalID === row.TreatmentCanalID);
          if (idx > -1) {
            this.treatmentModel.dataTreatmentEndoCanals.splice(idx, 1);
            this.canalDataSource.data = this.treatmentModel.dataTreatmentEndoCanals;
            this.canalDataSource._updateChangeSubscription();
          }
        });
      }
    });
  }

  onClearCanalRow(row: TreatmentEndoCanalDataModel) {
    this.dialogService.openConfirmDialog('Are you sure you want to clear this row?').subscribe((isConfirmed) => {
      if (isConfirmed) {
        // row.enumToothCanalID = this.emptyGuid;
        row.enumEndoPulpStatusID = this.emptyGuid;
        row.enumEndoEstimatedWorkLengthID = this.emptyGuid;
        row.enumEndoReferenceID = this.emptyGuid;
        row.enumEndoActualWorkLengthID = this.emptyGuid;
        row.enumEndoApicalCurv1LocID = this.emptyGuid;
        row.enumEndoApicalCurv2LocID = this.emptyGuid;
        row.enumEndoApicalCurvID = this.emptyGuid;
        row.enumEndoFirstFile2BindID = this.emptyGuid;
        row.enumEndoMasterApicalFileID = this.emptyGuid;
        row.enumEndoGuttaPerchaID = this.emptyGuid;
        row.enumEndoSealerID = this.emptyGuid;
        row.enumEndoFillID = this.emptyGuid;
        row.enumEndoMethodOfObturationID = this.emptyGuid;
        row.enumEndoInterAptMedID = this.emptyGuid;
        row.enumEndoCoronal1TypeID = this.emptyGuid;
        row.enumEndoCoronal2TypeID = this.emptyGuid;
        row.enumEndoCoronalPostSpaceID = this.emptyGuid;
        row.enumEndoSepID = this.emptyGuid;
        row.enumEndoFillTypeID = this.emptyGuid;
        row.enumEndoFillBrandID = this.emptyGuid;
        row.enumEndoFillSizeID = this.emptyGuid;
        row.enumEndoFillLocationID = this.emptyGuid;
        row.FillNumberOfUses = 0;
        row.selectedEnumId = '';

        this.treatmentService.saveCanalItem(row).subscribe((res) => {
          this.canalDataSource.data = [];

          const idx = this.treatmentModel.dataTreatmentEndoCanals.findIndex(p => p.TreatmentCanalID === row.TreatmentCanalID);
          if (idx > -1) {
            this.treatmentModel.dataTreatmentEndoCanals[idx] = res;
          }

          this.canalDataSource._updateChangeSubscription();
          this.canalDataSource.data = this.treatmentModel.dataTreatmentEndoCanals;
          this.canalDataSource._updateChangeSubscription();
        });
      }
    });
  }

  onAddCanalRow() {
    const model = new TreatmentEndoCanalDataModel();
    // For Canal order, this only works if all canals are for the current tooth
    model.CanalOrder = this.treatmentModel.dataTreatmentEndoCanals.length;
    model.TreatmentID = this.treatmentModel.TreatmentID;
    model.CaseWorkItemToothID = this.treatmentModel.CaseWorkItemTeeth[0].CaseWorkItemToothId;
    this.treatmentService.saveCanalItem(model).subscribe((res) => {
      this.treatmentModel.dataTreatmentEndoCanals.push(res);
      this.canalDataSource.data = this.treatmentModel.dataTreatmentEndoCanals;
      this.canalDataSource._updateChangeSubscription();
    });
  }

  getDisplayName(enumItemId: string, enums: EnumValidValueItemModel[]) {
    if (enums === undefined || enums === null || enums.length === 0)
      return null;
    const enumItem = enums.find(p => p.ValidValueItemId === enumItemId);
    if (enumItem) {
      return enumItem.ItemDisplayValue;
    } else {
      return null;
    }
  }

  onHeaderItemClicked(event: MouseEvent, headerName: string) {
    event.preventDefault();
    event.stopPropagation();

    let width = 400;
    const height = 400;

    const editModel = new TreatmentEndoEditColumnModel();
    editModel.model = this.treatmentModel;
    editModel.title = headerName;

    switch (headerName) {
      case 'Pulp Status':
        editModel.columnPropertyNames = ['enumEndoPulpStatusID'];
        editModel.columnEnums = [this.canalEnumService.pulpStatusEnums];
        break;
      case 'EWL':
        editModel.title = 'Estimated Work Length';
        editModel.columnPropertyNames = ['enumEndoEstimatedWorkLengthID'];
        editModel.columnEnums = [this.canalEnumService.estimatedWorkLengthEnums];
        break;
      case 'Reference':
        editModel.columnPropertyNames = ['enumEndoReferenceID'];
        editModel.columnEnums = [this.canalEnumService.referenceEnums];
        break;
      case 'AWL':
        editModel.title = 'Actual Work Length';
        editModel.columnPropertyNames = ['enumEndoActualWorkLengthID'];
        editModel.columnEnums = [this.canalEnumService.actualWorkLengthEnums];
        break;
      case 'Apical Curvature':
        width = 800;
        editModel.columnPropertyNames = ['enumEndoApicalCurv1LocID', 'enumEndoApicalCurv2LocID', 'enumEndoApicalCurvID'];
        editModel.columnEnums = [this.canalEnumService.apicalCurv1LocEnums, this.canalEnumService.apicalCurv2LocEnums, this.canalEnumService.apicalCurvEnums];
        break;
      case 'FFB':
        editModel.title = 'First File to Bind';
        editModel.columnPropertyNames = ['enumEndoFirstFile2BindID'];
        editModel.columnEnums = [this.canalEnumService.firstFile2BindEnums];
        break;
      case 'MAF':
        editModel.title = 'Master Apical File';
        editModel.columnPropertyNames = ['enumEndoMasterApicalFileID'];
        editModel.columnEnums = [this.canalEnumService.masterApicalFileEnums];
        break;
      case 'GPS':
        editModel.title = 'Gutta Percha';
        editModel.columnPropertyNames = ['enumEndoGuttaPerchaID'];
        editModel.columnEnums = [this.canalEnumService.guttaPerchaEnums];
        break;
      case 'Sealer':
        editModel.columnPropertyNames = ['enumEndoSealerID'];
        editModel.columnEnums = [this.canalEnumService.sealerEnums];
        break;
      case 'Fill':
        editModel.columnPropertyNames = ['enumEndoFillID'];
        editModel.columnEnums = [this.canalEnumService.fillEnums];
        break;
      case 'MoO':
        editModel.title = 'Method of Obturation';
        editModel.columnPropertyNames = ['enumEndoMethodOfObturationID'];
        editModel.columnEnums = [this.canalEnumService.methodOfObturationEnums];
        break;
      case 'IAM':
        editModel.title = 'Inter Apt Med';
        editModel.columnPropertyNames = ['enumEndoInterAptMedID'];
        editModel.columnEnums = [this.canalEnumService.interAptMedEnums];
        break;
      case 'Coronal Endo':
        width = 800;
        editModel.columnPropertyNames = ['enumEndoCoronal1TypeID', 'enumEndoCoronal2TypeID', 'enumEndoCoronalPostSpaceID'];
        editModel.columnEnums = [this.canalEnumService.coronal1TypeEnums, this.canalEnumService.coronal2TypeEnums, this.canalEnumService.coronalPostSpaceEnums];
        break;
    }

    const dialogRef = this.dialog.open(TreatmentEndoEditColumnDialogComponent, {
      panelClass: ['dialog', 'allow-context-menu'],
      data: editModel,
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.treatmentModel = response.treatmentModel;
        // Update the enum lists based on which header was clicked
        switch (editModel.title) {
          case 'Pulp Status':
            this.updateEnumList(this.canalEnumService.pulpStatusEnums, response.dropdownModels.lengthOriginal);
            break;
          case 'Estimated Work Length':
            this.updateEnumList(this.canalEnumService.estimatedWorkLengthEnums, response.dropdownModels.lengthOriginal);
            break;
          case 'Reference':
            this.updateEnumList(this.canalEnumService.referenceEnums, response.dropdownModels.lengthOriginal);
            break;
          case 'Actual Work Length':
            this.updateEnumList(this.canalEnumService.actualWorkLengthEnums, response.dropdownModels.lengthOriginal);
            break;
          case 'Apical Curvature':
            this.updateEnumList(this.canalEnumService.apicalCurv1LocEnums, response.dropdownModels.lengthOriginal);
            this.updateEnumList(this.canalEnumService.apicalCurv2LocEnums, response.dropdownModels.models2);
            this.updateEnumList(this.canalEnumService.apicalCurvEnums, response.dropdownModels.models3);
            break;
          case 'First File to Bind':
            this.updateEnumList(this.canalEnumService.firstFile2BindEnums, response.dropdownModels.lengthOriginal);
            break;
          case 'Master Apical File':
            this.updateEnumList(this.canalEnumService.masterApicalFileEnums, response.dropdownModels.lengthOriginal);
            break;
          case 'Gutta Percha':
            this.updateEnumList(this.canalEnumService.guttaPerchaEnums, response.dropdownModels.lengthOriginal);
            break;
          case 'Sealer':
            this.updateEnumList(this.canalEnumService.sealerEnums, response.dropdownModels.lengthOriginal);
            break;
          case 'Fill':
            this.updateEnumList(this.canalEnumService.fillEnums, response.dropdownModels.lengthOriginal);
            break;
          case 'Method of Obturation':
            this.updateEnumList(this.canalEnumService.methodOfObturationEnums, response.dropdownModels.lengthOriginal);
            break;
          case 'Inter Apt Med':
            this.updateEnumList(this.canalEnumService.interAptMedEnums, response.dropdownModels.lengthOriginal);
            break;
          case 'Coronal Endo':
            this.updateEnumList(this.canalEnumService.coronal1TypeEnums, response.dropdownModels.lengthOriginal);
            this.updateEnumList(this.canalEnumService.coronal2TypeEnums, response.dropdownModels.models2);
            this.updateEnumList(this.canalEnumService.coronalPostSpaceEnums, response.dropdownModels.models3);
            break;
        }

        this.canalDataSource.data = this.treatmentModel.dataTreatmentEndoCanals;
        // Trigger change detection
        this.cdr.detectChanges();
      }
    });
  }

  private updateEnumList(existingEnums: EnumValidValueItemModel[], newDropdownModels: TdoDropdownModel[]) {
    if (!newDropdownModels || !existingEnums) return;
    const newItemsMap = new Map(
      newDropdownModels.map(model => [model.value?.ValidValueItemId ?? model.value?.validValueItemId, model])
    );

    existingEnums.forEach(existingItem => {
      const newItem = newItemsMap.get(existingItem.ValidValueItemId);
      if (newItem) {
        existingItem.ItemDisplayValue = newItem.label;
        newItemsMap.delete(existingItem.ValidValueItemId);
      }
    });

    newItemsMap.forEach(newItem => {
      const value = newItem.value ?? newItem;  // Handle both structures
      existingEnums.push({
        ChildValidValueId: null,
        ColorSchemeId: null,
        IconIDSVG: null,
        IconSet: null,
        ItemDisplayValue: newItem.label,
        ItemName: value.ItemName,
        ItemOrder: existingEnums.length,
        ItemSValue: value.ItemSValue,
        ValidValueId: value.ValidValueId,
        ValidValueItemId: value.ValidValueItemId,
        enumValidValue: value.enumValidValue,
        isSystem: true,
        ChildValidValue: null,
        isSelected: false,
        isPrimary: false,
       xauditCreatedBy: null,
        xauditCreatedOn: null,
        xauditDeleted: false,
        xauditModifiedBy: null,
        xauditModifiedOn: null,
        xauditTableRowID: null,
        objectId: ''
      });
    });
  }

 /* private generateGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }*/

  onUpdateRow(row: TreatmentEndoCanalDataModel) {
    const dialogRef = this.dialog.open(TreatmentEndoEditRowDialogComponent, {
      width: '1550px',
      height: '900px',
      panelClass: ['dialog', 'allow-context-menu'],
      data: {
        treatmentModel: this.treatmentModel,
        canalModel: row
      },
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        //
      }
    });
  }

  onAutoFillRowClick(num: number, row: TreatmentEndoCanalDataModel) {
    switch (num.toString()) {
      case this.treatmentAutofillModels[0].AutoFillName:
        this.autoFillNullCanalRows(this.treatmentAutofillModels[0], row);
        break;
      case this.treatmentAutofillModels[1].AutoFillName:
        this.autoFillNullCanalRows(this.treatmentAutofillModels[1], row);
        break;
      case this.treatmentAutofillModels[2].AutoFillName:
        this.autoFillNullCanalRows(this.treatmentAutofillModels[2], row);
        break;
      case this.treatmentAutofillModels[3].AutoFillName:
        this.autoFillNullCanalRows(this.treatmentAutofillModels[3], row);
        break;
    }
  }

  autoFillNullCanalRows(cfg: TreatmentEndoAutofillItemModel, model: TreatmentEndoCanalDataModel) {
    if (!model.enumEndoPulpStatusID || model.enumEndoPulpStatusID === this.emptyGuid) {
      model.enumEndoPulpStatusID = cfg.enumEndoPulpStatusID;
    }
    if (!model.enumEndoEstimatedWorkLengthID || model.enumEndoEstimatedWorkLengthID === this.emptyGuid) {
      model.enumEndoEstimatedWorkLengthID = cfg.enumEndoEstimatedWorkLengthID;
    }
    if (!model.enumEndoReferenceID || model.enumEndoReferenceID === this.emptyGuid) {
      model.enumEndoReferenceID = cfg.enumEndoReferenceID;
    }
    if (!model.enumEndoActualWorkLengthID || model.enumEndoActualWorkLengthID === this.emptyGuid) {
      model.enumEndoActualWorkLengthID = cfg.enumEndoActualWorkLengthID;
    }
    if (!model.enumEndoApicalCurv1LocID || model.enumEndoApicalCurv1LocID === this.emptyGuid) {
      model.enumEndoApicalCurv1LocID = cfg.enumEndoApicalCurv1LocID;
    }
    if (!model.enumEndoApicalCurv2LocID || model.enumEndoApicalCurv2LocID === this.emptyGuid) {
      model.enumEndoApicalCurv2LocID = cfg.enumEndoApicalCurv2LocID;
    }
    if (!model.enumEndoApicalCurvID || model.enumEndoApicalCurvID === this.emptyGuid) {
      model.enumEndoApicalCurvID = cfg.enumEndoApicalCurvID;
    }
    if (!model.enumEndoFirstFile2BindID || model.enumEndoFirstFile2BindID === this.emptyGuid) {
      model.enumEndoFirstFile2BindID = cfg.enumEndoFirstFile2BindID;
    }
    if (!model.enumEndoMasterApicalFileID || model.enumEndoMasterApicalFileID === this.emptyGuid) {
      model.enumEndoMasterApicalFileID = cfg.enumEndoMasterApicalFileID;
    }
    if (!model.enumEndoGuttaPerchaID || model.enumEndoGuttaPerchaID === this.emptyGuid) {
      model.enumEndoGuttaPerchaID = cfg.enumEndoGuttaPerchaID;
    }
    if (!model.enumEndoSealerID || model.enumEndoSealerID === this.emptyGuid) {
      model.enumEndoSealerID = cfg.enumEndoSealerID;
    }
    if (!model.enumEndoFillID || model.enumEndoFillID === this.emptyGuid) {
      model.enumEndoFillID = cfg.enumEndoFillID;
    }
    if (!model.enumEndoMethodOfObturationID || model.enumEndoMethodOfObturationID === this.emptyGuid) {
      model.enumEndoMethodOfObturationID = cfg.enumEndoMethodOfObturationID;
    }
    if (!model.enumEndoInterAptMedID || model.enumEndoInterAptMedID === this.emptyGuid) {
      model.enumEndoInterAptMedID = cfg.enumEndoInterAptMedID;
    }
    if (!model.enumEndoCoronal1TypeID || model.enumEndoCoronal1TypeID === this.emptyGuid) {
      model.enumEndoCoronal1TypeID = cfg.enumEndoCoronal1TypeID;
    }
    if (!model.enumEndoCoronal2TypeID || model.enumEndoCoronal2TypeID === this.emptyGuid) {
      model.enumEndoCoronal2TypeID = cfg.enumEndoCoronal2TypeID;
    }
    if (!model.enumEndoCoronalPostSpaceID || model.enumEndoCoronalPostSpaceID === this.emptyGuid) {
      model.enumEndoCoronalPostSpaceID = cfg.enumEndoCoronalPostSpaceID;
    }

    this.treatmentService.saveCanalItem(model).subscribe((res) => {
      const idx = this.treatmentModel.dataTreatmentEndoCanals.findIndex(p => p.TreatmentCanalID === model.TreatmentCanalID);
      if (idx > -1) {
        this.treatmentModel.dataTreatmentEndoCanals[idx] = res;
      }
    });
  }

  onAutoFillAllClick(num: number) {
    let autoFillModel: TreatmentEndoAutofillItemModel;
    switch (num.toString()) {
      case this.treatmentAutofillModels[0].AutoFillName:
        autoFillModel = this.treatmentAutofillModels[0];
        break;
      case this.treatmentAutofillModels[1].AutoFillName:
        autoFillModel = this.treatmentAutofillModels[1];
        break;
      case this.treatmentAutofillModels[2].AutoFillName:
        autoFillModel = this.treatmentAutofillModels[2];
        break;
      case this.treatmentAutofillModels[3].AutoFillName:
        autoFillModel = this.treatmentAutofillModels[3];
        break;
    }

    for (const mod of this.treatmentModel.dataTreatmentEndoCanals) {
      this.autoFillNullCanalRows(autoFillModel, mod);
    }
  }

  getTime(date: Date) {
    if (date) {
      return new Date(date).toLocaleTimeString();
    } else {
      return '';
    }
  }


  getDate(date: Date) {
    if (date) {
      return new Date(date).toLocaleDateString();
    } else {
      return '';
    }
  }

  onCompleteDateFocus(event: FocusEvent) {
    if (!this.treatmentModel.CompleteDate) {
      this.treatmentModel.CompleteDate = new Date();
      this.saveTreatment();
      this.saveNote();
    }
  }

  onCompleteDateChange(event: MatDatepickerInputEvent<any, any>) {
    this.treatmentModel.CompleteDate = event.value;
    this.saveTreatment();
  }

  onCompleteDateInputFinish(event: any) {
    this.treatmentModel.CompleteDate = new Date(event);
    this.saveTreatment();
  }

  onAssistantChange(event: TdoDropdownChange) {
    if (!event.isUserInput) {
      return;
    }
    this.treatmentModel.AssistantUserID = event.value.UserID;
    this.saveTreatment();
  }

  getAssistant() {
    if (this.treatmentModel && this.treatmentModel?.AssistantUserID) {
      const usr = this.assistants.find(p => p?.UserID?.toLowerCase() === this.treatmentModel?.AssistantUserID?.toLowerCase());
      if (usr) {
        return usr;
      }
    }
    return null;
  }

  private note: string = '';
  saveNote() {
    const m = this.treatmentModel;

    //var  anesthesia : TreatmentEndoAnesthesiaDataModel[];

    const assistant = this.getAssistant();
    const util = new TreatmentUtils(this.staticDataService);

    this.note = 'Tooth: ' +this.getDocumentFormToothNumber()+'\r\n';

    this.note += 'Treatment Completion Date: ' + this.getDate(m.CompleteDate) + '\r\n';

    this.note += 'Assistant: ';

    if(assistant !==null)
      this.note +=  (assistant.FirstName !== null ? assistant.FirstName : '') + ' ' + (assistant.LastName !== null ? assistant.LastName : '') ;

    this.note += '\r\n';
    this.note += '\r\n Canals\r\n';
    this.note += '===============================\r\n';

    for (const mod of m.dataTreatmentEndoCanals) {
      this.note += util.checkEnum(mod.enumToothCanalID, '', true);
      this.note += util.checkEnum(mod.enumEndoPulpStatusID, ' ==> ', true);
      this.note += util.checkEnum(mod.enumEndoEstimatedWorkLengthID, ' ==> ', true);
      this.note += util.checkEnum(mod.enumEndoReferenceID, ' ==> ', true);
      this.note += util.checkEnum(mod.enumEndoActualWorkLengthID, ' ==> ', true);
      this.note += util.checkEnum(mod.enumEndoApicalCurvID, ' ==> ', true);
      this.note += util.checkEnum(mod.enumEndoApicalCurv2LocID, ', ', true);
      this.note += util.checkEnum(mod.enumEndoApicalCurv2LocID, ', ', true);
      this.note += util.checkEnum(mod.enumEndoFirstFile2BindID, ' ==> ', true);
      this.note += util.checkEnum(mod.enumEndoMasterApicalFileID, ' ==> ', true);
      this.note += util.checkEnum(mod.enumEndoGuttaPerchaID, ' ==> ', true);
      this.note += util.checkEnum(mod.enumEndoSealerID, ' ==> ', true);
      this.note += util.checkEnum(mod.enumEndoFillID, ' ==> ', true);
      this.note += util.checkEnum(mod.enumEndoMethodOfObturationID, ' ==> ', true);
      this.note += util.checkEnum(mod.enumEndoInterAptMedID, ' ==> ', true);
      this.note += util.checkEnum(mod.enumEndoCoronalPostSpaceID, ' ==> ', true);
      this.note += util.checkEnum(mod.enumEndoCoronal1TypeID, ', ', true);
      this.note += util.checkEnum(mod.enumEndoCoronal2TypeID, ', ', true);
      this.note += '\r\n';
    }

    this.note += '\r\n';
    this.note += '\r\n';
    this.note += util.checkEnum(m.enumEndoOcclusionReductionID, 'Occlusion Reduction: ');
    this.note += util.checkEnum(m.enumEndoIrrigationProtocolID, 'Irrigation Protocol: ');
    this.note += util.checkEnum(m.enumEndoInstrumentProtocolID, 'Instrument Protocol: ');
    this.note += util.checkEnum(m.enumEndoIrrigationVolumUsedID, 'Total Irrigation Volume Used: ');
    this.note += util.checkEnum(m.enumEndoBleedingID, 'Bleeding: ');
    this.note += util.checkEnum(m.enumEndoIntraOperatoryPainID, 'Intra-Operative Pain: ');
    this.note += util.checkEnum(m.enumEndoExistingRestorationID, 'Existing Restoration: ');
    this.note += util.checkEnum(m.enumEndoRequestedCoronalEndoID, 'Request Coronal Endo: ');
    this.note += 'Perf type: ' + this.getPerfType() + '\r\n';
    this.note += util.checkEnum(m.enumEndoClampID, 'Clamp: ');
    this.note += util.checkEnum(m.enumEndoPretreatmentID, 'Pretreatment: ');
    this.note += util.checkEnum(m.enumEndoBiteBlock, 'Bite Block: ');
    this.note += util.checkBool(m.isRequiredAnasthesia, 'Required Additional Anesthesia');
    this.note += util.checkBool(m.isWasNotSinglVisitTreatment, 'Was not a single treatment');
    this.note += util.checkBool(m.isHadNaOClevent, 'Had NaOCI event');


    if (this.treatmentModel && this.treatmentModel.dataTreatmentEndoPerforations && this.treatmentModel.dataTreatmentEndoPerforations.length > 0) {
      this.note += ' \r\n';
      this.note += 'Perforation\r\n';
      this.note += '=========================================================\r\n';
      const perforation = this.treatmentModel.dataTreatmentEndoPerforations[0];
      this.note += util.checkEnum(perforation.enumToothCanalID, 'Canal: ', true);
      this.note += '\r\n';
      this.note += util.checkEnum(perforation.enumEndoPerfCrestalID, 'Crestal: ', true);
      this.note += '\r\n';
      this.note += util.checkEnum(perforation.enumEndoPerfSizeID, 'Size: ', true);
      this.note += '\r\n';
      this.note += util.checkEnum(perforation.enumEndoPerfTypeID, 'Type: ', true);
      this.note += '\r\n';
      this.note += util.checkEnum(perforation.enumEndoPerfCausedByID, 'Caused By: ', true);
      this.note += '\r\n';
      this.note += util.checkEnum(perforation.enumEndoPerfPriorRepaireID, 'Prior Repair: ', true);
      this.note += '\r\n';
      this.note += util.checkEnum(perforation.enumEndoPerfTimeSincePerfID, 'Time Since Perforation: ', true);
      this.note += '\r\n';
      this.note += util.checkEnum(perforation.enumEndoPerfRepairMaterialID, 'Repair Material: ', true);
      this.note += '\r\n';
      this.note += perforation.isPerfRadioDiscern ? 'Is Perforation radiologically discernible?: Yes' : 'Is Perforation radiologically discernible?: No';
      this.note += '\r\n';
      this.note += perforation.isPerfClinicallyDiscern ? 'Is Perforation clinically discernible?: Yes' : 'Is Perforation clinically discernible?: No';
      this.note += '\r\n';
      this.note += perforation.isPerfSurgicallyAccessible ? 'Is Perforation surgically accessible?: Yes' : 'Is Perforation surgically accessible?: No';
    }


    let anesthesia: any[] = [];
    let anote='';
    this.treatmentService.getAnesthesia(this.globals.currentPatientId).subscribe((dataRes) => {
      anesthesia = dataRes;

      if(!(anesthesia == null || anesthesia == undefined) && anesthesia.length > 0)  {

        anote += ' \r\n';
        anote += 'Anesthesia\r\n';
        anote += '=========================================================\r\n';

        anesthesia.forEach( a => {


          anote += 'Date: '+this.getDate(new Date(a.AnesthesiaDate)) ;
          if(a.isN2O == true)
          {
            anote += '\r\n N2O Time On: ' + this.getTime(new Date(a.N2OxN2OTimeOn)) + ' Off: ' + this.getTime(new Date(a.N2OxN2OTimeOff))  +' Mixture Flow: N2O: '+ util.checkNull(a.N2OxMixLpMxN2O) + 'L/min'+ '\r\n';
            anote += '  O2 Time On: ' + this.getTime(new Date(a.N2OxO2TimeOn)) + ' Off: ' + this.getTime(new Date(a.N2OxO2TimeOff)) +' Mixture Flow:  O2: '+ util.checkNull(a.N2OxMixLpMxO2) + 'L/min'  + '\r\n';
          }
          else  {
              anote +=  util.checkEnum(a.enumAnestQuantityID , ' Quantity: ', true);
              anote +=  util.checkEnum(a.enumAnestTypeID , ' Type: ', true);
              anote +=  util.checkEnum(a.enumAnestAnesthesiaID , ' Administered: ', true);
              if(a.AnesthesiaExpDate ==null || a.AnesthesiaExpDate == undefined) {
                anote +=  ' Exp.Date: ';
              }
              else {
                anote += ' Exp.Date: ' + this.getDate(new Date(a.AnesthesiaExpDate));
              }
              anote +=  ' Batch: '+ util.checkNull( a.AnesthesiaBatch)   + '\r\n';
          }

        });
      }
      
      // Always call finaliseNoteSaving for anesthesia, even if empty
      this.finaliseNoteSaving(anote);  // step count 2
    });

    let fractures: any[] = [];
    let fnote='';  
    this.treatmentService.getFracturesText(this.form.dataPatientCaseItemFormTeeth[0].CaseWorkItemToothId).subscribe((res) => {
      fractures = res;

      if(!(fractures == null || fractures == undefined) && fractures.length > 0) {
        fnote += ' \r\n';
        fnote += 'Fractures\r\n';
        fnote += '=========================================================\r\n';

        fractures.forEach(f => {
          fnote += 'Fracture: ' + util.checkNull(f.FractureLocationText);
          fnote += ', Type: ' +util.checkNull(f.FractureTypeText);
          fnote += ', Extension: '+util.checkNull(f.FractureExtensionText );
          fnote += ', TransIllumination: ' +util.checkNull(f.EndoFractureTransilluminationText);
          fnote += '\r\n';
        });
      }

      // Always call finaliseNoteSaving for fractures, even if empty
      this.finaliseNoteSaving(fnote); // step count 3
    });

  }  //save note
  
  
  stepcount = 1;
  finaliseNoteSaving(note: string ) {
    this.stepcount++;
       

    this.note += note;

    if(this.stepcount < this.NOTE_SAVING_STEP_THRESHOLD) {
      return;
    }


    const mod = new TdoNoteSaveModel();
    mod.text = this.note;
    mod.patientId = this.globals.currentPatientId;

    const assoc = new TdoNoteAssociatedObject();
    assoc.objectId = this.treatmentModel.TreatmentID;
    assoc.parentObjectName = 'dataTreatmentEndo';
    mod.associatedObjects = [];
    mod.associatedObjects.push(assoc);
    mod.categoryEnumIds = [NoteCategoryEnum.TreatmentPageSummary];
    mod.typeEnumIds = ['00000019-1000-0000-0000-000000000002'];
    this.notesService.saveNote(mod).subscribe((res) => {
      this.messagingService.sendComponentMessage(MessagingConstants.NOTES_REFRESH, {});
    });
  }

  onUserInput(event: boolean) {
    this.isUserInput = event;
  }
}
